var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var BarChart2 = function BarChart2(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18 20a1 1 0 1 0 2 0V5a1 1 0 1 0-2 0v15Zm-6 1a1 1 0 0 1-1-1V9a1 1 0 1 1 2 0v11a1 1 0 0 1-1 1Zm-7 0a1 1 0 0 1-1-1v-7a1 1 0 1 1 2 0v7a1 1 0 0 1-1 1Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default BarChart2;